"use strict";
var apiURL = null;
if (process.env.NODE_ENV){
    if (process.env.NODE_ENV == "production") {
        apiURL = "https://microservices.kizansolutions.com/api";
    } else if (process.env.NODE_ENV == "staging") {
        apiURL = "https://staging.microservices.kizansolutions.com/api";
    } else if (process.env.NODE_ENV == "dev" || process.env.NODE_ENV == "testing" || process.env.NODE_ENV == "test") {
        apiURL = "https://test.microservices.kizansolutions.com/api";
    }
}else{
    apiURL = "https://test.microservices.kizansolutions.com/api";
}
module.exports = apiURL;
